import { Link } from 'react-router-dom';

function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20Korean%20manhwa%20style%20illustration%20background%2C%20soft%20gradient%20of%20coral%20pink%20and%20warm%20cream%2C%20abstract%20brush%20strokes%20with%20subtle%20cherry%20blossom%20petals%2C%20gentle%20watercolor%20texture%2C%20dreamy%20atmosphere%2C%20clean%20composition%2C%20no%20text%2C%20artistic%20background%20only&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="韩漫之家 - 高清韩国漫画在线阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/10 to-background-50"></div>
      
      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto text-center">
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-5 tracking-wide">
            探索韩漫的无限世界
          </h1>
          <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
            汇集全网高清韩国漫画资源，浪漫爱情、奇幻冒险、热血动作、悬疑惊悚……
            <br className="hidden sm:block" />
            免费在线阅读，发现你心中的下一部神作
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/romance"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
          <div className="flex items-center justify-center gap-8 mt-10">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">2000+</p>
              <p className="text-xs text-background-300 mt-1">漫画作品</p>
            </div>
            <div className="w-px h-10 bg-background-300/30"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">8</p>
              <p className="text-xs text-background-300 mt-1">漫画分类</p>
            </div>
            <div className="w-px h-10 bg-background-300/30"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">500万+</p>
              <p className="text-xs text-background-300 mt-1">忠实读者</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;